export class SchemaVersionNotFound extends Error {
  constructor(id, code, message, detail) {
    super(message);
    this.code = code;
    this.id = id;
    this.detail = detail;
  }
}

export class SchemaExtensionNotFound extends Error {
  constructor(id, code, message, detail) {
    super(message);
    this.code = code;
    this.id = id;
    this.detail = detail;
  }
}

export class NamespaceNotFound extends Error {
  constructor(id, code, message, detail) {
    super(message);
    this.code = code;
    this.id = id;
    this.detail = detail;
  }
}

export class SchemaNotFound extends Error {
  constructor(id, code, message, detail) {
    super(message);
    this.code = code;
    this.id = id;
    this.detail = detail;
  }
}

export class NamespaceAlreadyExists extends Error {
  constructor(id, code, message, detail) {
    super(message);
    this.code = code;
    this.id = id;
    this.detail = detail;
  }
}

export class ForbiddenAccessInternalAPI extends Error {
  constructor(id, code, message, detail) {
    super(message);
    this.code = code;
    this.id = id;
    this.detail = detail;
  }
}

export class NoAccessPermission extends Error {
  constructor(id, code, message, detail) {
    super(message);
    this.code = code;
    this.id = id;
    this.detail = detail;
  }
}

export class InvalidParameterError extends Error {
  constructor(id, code, message, detail) {
    super(message);
    this.code = code;
    this.id = id;
    this.detail = detail;
  }
}
